import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import useEmblaCarousel from "embla-carousel-react";

import { text } from "../../text";
import { URLS } from "../../config";
import { hooks } from "../../hooks";
import { utils } from "../../utils";
import { svg } from "../../assets/svg";
import { theme } from "../../constants";
import { components } from "../../components";
import { course as elements } from "../../course";
import { review as reviews } from "../../reviews";

import categoriesdata from "../../staticdata/categories";
import properties from "../../staticdata/properties";
import { reviewsData } from "../../staticdata/reviewData";
import { CourseCard } from "../../course/CourseCard";
import { SerachResultCard } from "../../course/SerachResultCard";
import { FilterSvg } from "../../assets/svg/FilterSvg";
import homeimg from '../../assets/nestfin/home.png'
import logo from "../../assets/nestfin/NexfinPng.png"
import { BottomTabBar } from "../../navigation/BottomTabBar";
import { fetchPropertyByFilters, updateLeadProfile, viewLeadProfile } from "../../environment";
import useApi from "../../customHook/useApi";
import { callService } from "../../customHook/callService";
import { toast } from 'react-toastify';



export interface Feature {
  feature_id: number;
  feature_name: string;
  icon: string;
}

export interface PropertyType {
  property_id: string;
  property_name: string;
  address: string;
  locality_id: string;
  locality_name: string | null;
  city_id: string;
  city_name: string;
  pincode: string;
  state: string;
  features: Feature[] | null;
  photos: any; // can refine this later
  minimum_rent: number;
}

export interface FilterResponse {
  success: boolean;
  statusCode: number;
  data: PropertyType[];
}



type Profile = {
  leadId: string | null;
  full_name: string | null;
  email: string | null;
  phone_number: string | null;
  gender: string | null;
  dob: string | null;
  pref_budget_min_range: number | null;
  pref_budget_max_range: number | null;
  pref_city_name: string | null;
  pref_city_id: string | null;
  pref_locality_name: string | null;
  pref_locality_id: string | null;

}

export interface profileResponse {
  success: boolean;
  statusCode: number;
  data: Profile;
  message?: string;
}

export const Home2: React.FC = () => {


  const navigate = hooks.useNavigate();
  const location = useLocation();
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(false);
  const [emblaRef, emblaApi] = useEmblaCarousel();
  const [activeIndex, setActiveIndex] = useState(0);
  const [coursesData, setCoursesData] = useState([]);
  const [bannersData, setBannersData] = useState([]);
  // const [categoriesData, setCategoriesData] = useState < any > [];
  const [viewport, setViewport] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const [isFullscreen, setIsFullscreen] = useState(false);
  const [startIndex, setStartIndex] = useState(0);




  const [filterAPI, setFilterAPI] = useState<{
    leadId: string;
    selectedLocalityId: string;
    genderAPI: string;
    minAmount: number;
    maxAmount: number;
  }>({
    leadId: "",  // coming from localstorage
    selectedLocalityId: "",
    genderAPI: "",
    minAmount: 2000,
    maxAmount: 8000
  });


  // API CALL for show the data with filter
  const {
    data: propertyData,
    loading: propertyLoading,
    callApi: fetchProperty,
  } = useApi<FilterResponse>(fetchPropertyByFilters, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });


  // View Profile API CALL
  const {
    data: profileData,
    loading: profileLoading,
    callApi: fetchProfile,
  } = useApi<profileResponse>(viewLeadProfile, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });


  // 1. API Call Trigger (on mount)
  useEffect(() => {
    const leadId = localStorage.getItem("lead_profile_id");
    if (leadId) {
      fetchProfile({ leadId });
    }
  }, []);

  useEffect(() => {
    console.log(profileData, "profileData from home page ");
  }, [profileData])




  // api call for update user profile
  // UPDATE PROFILE API
  const {
    data: UpdateProfileData,
    loading: UpdateProfileLoading,
    callApi: updatePayload,
  } = useApi<profileResponse>(updateLeadProfile, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  useEffect(() => {
    if (UpdateProfileData?.success) {
      console.log("Profile updated successfully");
      // Optionally show toast/snackbar/redirect
      // toast.success("Profile updated successfully");
    }
  }, [UpdateProfileData]);

  useEffect(() => {
    if (profileData) {
      const leadId = localStorage.getItem("lead_profile_id");
      const genderAPI = sessionStorage.getItem("genderAPI") || "";
      const maxAmountStr = sessionStorage.getItem("maxAmount") || "";
      const minAmountStr = sessionStorage.getItem("minAmount") || "";
      const localityId = sessionStorage.getItem("SelectedLocalityId") || "";
      const cityId = sessionStorage.getItem("selectedCityId") || "";


      const id = localityId.split(",")
      console.log(id[0], "Vikas kumar localityId");

      const updatedPayload = {
        leadId: leadId,
        full_name: profileData?.data?.full_name,
        email: profileData?.data?.email,
        phone_number: profileData?.data?.phone_number,
        gender: genderAPI,
        dob: profileData?.data?.dob,
        pref_budget_min_range: String(minAmountStr),
        pref_budget_max_range: String(maxAmountStr),
        pref_city_id: cityId,
        pref_locality_id: id[0],
      };

      console.log("Merged update payload:", updatedPayload);
      updatePayload(updatedPayload);
    }
  }, [profileData]); // run when viewProfile API returns






  // ***************
  useEffect(() => {
    const selectedLocalityId = sessionStorage.getItem("SelectedLocalityId") || "";
    const genderAPI = sessionStorage.getItem("genderAPI") || "";
    let maxAmountStr = sessionStorage.getItem("maxAmount");
    let minAmountStr = sessionStorage.getItem("minAmount");

    if (!minAmountStr) {
      minAmountStr = "1000";
      sessionStorage.setItem("minAmount", minAmountStr);
    }

    if (!maxAmountStr) {
      maxAmountStr = "30000";
      sessionStorage.setItem("maxAmount", maxAmountStr);
    }

    const leadId = localStorage.getItem("lead_profile_id") || "";

    // ✅ Set API filters for future use
    setFilterAPI({
      leadId,
      selectedLocalityId,
      genderAPI,
      minAmount: Number(minAmountStr),
      maxAmount: Number(maxAmountStr),
    });

    // ✅ Call API immediately
    const payload = {
      // leadId,
      // gender: genderAPI,
      // minAmount: Number(minAmountStr),
      // maxAmount: Number(maxAmountStr),
      // localityId: selectedLocalityId,
      leadId: "LEAD-B-2025-05-001",
      gender: "GENDER_MALE",
      minAmount: 1,
      maxAmount: 100000,
      localityId: "5,7",
    };

    fetchProperty(payload);
    console.log("Called API immediately with:", payload);
  }, []);




  // Log when propertyData updates


  useEffect(() => {
    if (propertyData) {
      console.log("✅ API Response - propertyData:", propertyData);
    }
  }, [propertyData]);




  useEffect(() => {
    const handleResize = () => {
      setViewport({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };
    scrollToTop();
  }, [pathname]);
  const handleSlideChange = () => {
    if (emblaApi) {
      setActiveIndex(emblaApi.selectedScrollSnap());
    }
  };
  useEffect(() => {
    if (emblaApi) {
      emblaApi.on("select", handleSlideChange);
    }
  }, [emblaApi]);
  useEffect(() => {
    getData();
  }, []);


  // Call Lead Api 
  useEffect(() => {
    const leadId = localStorage.getItem("lead_profile_id") || "";
    const gender = sessionStorage.getItem("gender");
    const state = "DELHI/NCR";
    const city = sessionStorage.getItem("selectedCity") || "Noida";
    const selectedLocalities = JSON.parse(sessionStorage.getItem("selectedLocality") || "[]");
    const maxAmount = sessionStorage.getItem("maxAmount") || "30000";
    const minAmount = sessionStorage.getItem("minAmount") || "0";


    if (!leadId) return;

    const payload = [
      { param: "GENDER", value: gender },
      { param: "STATE", value: state },
      { param: "CITY", value: city },
      { param: "LOCALITY", value: selectedLocalities },
      { param: "MAXAMOUNT", value: maxAmount },
      { param: "MINAMOUNT", value: minAmount },
    ];

    callService("VIEW_PROPERTY", payload)
      .then((res) => {
        console.log("✅ VIEW_PROPERTY response:", res);
      })
      .catch((err) => {
        console.error("❌ VIEW_PROPERTY failed:", err);
      });
  }, []);




  // old api 
  const getData = async () => {
    setLoading(false);

    // try {
    //   const results = await Promise.allSettled([
    //     axios.get(URLS.GET_COURSES),
    //     axios.get(URLS.GET_CATEGORIES),
    //     axios.get(URLS.GET_BANNERS),
    //   ]);

    //   const coursesResponse = results[0];
    //   const categoriesResponse = categoriesdata;
    //   const bannersResponse = results[2];

    //   if (coursesResponse.status === "fulfilled") {
    //     setCoursesData(coursesResponse.value.data.courses);
    //   } else {
    //     console.error("Error fetching courses:", coursesResponse.reason);
    //   }

    //   if (categoriesResponse.status === "fulfilled") {
    //     // setCategoriesData(categoriesResponse?.categories);
    //   } else {
    //     // console.error('Error fetching categories:', categoriesResponse?.reason);
    //   }

    //   if (bannersResponse.status === "fulfilled") {
    //     setBannersData(bannersResponse.value.data.banners);
    //   } else {
    //     console.error("Error fetching banners:", bannersResponse.reason);
    //   }
    // } catch (error) {
    //   console.error("Unexpected error:", error);
    // } finally {
    //   setLoading(false);
    // }
  };



  const filterData = location?.state?.filter;
  // from locaiton value
  useEffect(() => {
    console.log(filterData, "from course details page");

  }, [])



  // component Start here

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        goBack={false}
        line={false}
        leftlogo={true}
        rightlogo={true}
        // search={true}
        filter={false}
        // logo={true}
        title={""}

        centerImageSrc={logo}

      />
    );
  };


  const renderBottomTabBar = (): JSX.Element => {
    return <BottomTabBar />;
  };


  const renderIndicator = (): JSX.Element => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          bottom: 20,
          left: 20,
          flexDirection: "row",
          gap: 8,
        }}
      >
        {bannersData?.map((item: any, index: number) => {
          const isSelected = index === activeIndex;
          return (
            <div
              style={{
                background: isSelected
                  ? "#7065F0"
                  : theme.colors.secondaryTextColor,
                width: 10,
                // width: isSelected ? 25 : 10,
                height: 10,
                borderRadius: 5,
              }}
              key={index}
            />
          );
        })}
      </div>
    );
  };

  const renderCarouselContent = (): JSX.Element => {
    return (
      <div
        className="embla"
        ref={emblaRef}
        style={{ marginBottom: 20, marginTop: 40 }}
      >
        <div className="embla__container">
          {bannersData.map((item: any, index: number, array: any[]) => {
            return (
              <div
                key={item.id}
                className="embla__slide"
                style={{
                  position: "relative",
                  width: "100%",
                  overflow: "hidden",
                  cursor: "pointer",
                  userSelect: "none",
                  padding: "0 20px",
                }}
              >
                <img
                  src={item.banner}
                  style={{
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: 10,
                  }}
                  onClick={() => {
                    navigate("/course-details", {
                      state: { course: coursesData[0] },
                    });
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  };


  const renderSearchBar2 = (): JSX.Element => {
    return (
      <div className="container">
        <div className="searchBar">
          <svg.SearchSvg />
          <input
            type="text"
            placeholder="Search City, locality, landmark here"
            className="searchInput"
            onChange={() => console.log("onchangeActive")
            }
            onClick={() => navigate("/onbording6")}

          />
          <div
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/onbording7")}

          >
            <FilterSvg color={"#7065F0"} />
          </div>

        </div>
        <p style={{ fontSize: "13px", marginTop: "20px" }}>Selected Locality</p>
        <div className="location-tag-group" style={{ gap: "5px" }}>

          {/* <div className='addMoreBtn' onClick={() => navigate('/onbording6')} style={{ padding: "10px 25px" }} >+ Add More</div> */}
          {filterData.selectedLocality?.map((city: string, index: number) => (
            <div key={index} className="location-tag-wrapper" style={{ padding: "5px 10px", marginBottom: "0", background: "none", backgroundColor: "#7065f0d6", color: "white" }} >

              {city}
            </div>
          ))}
        </div>

      </div >
    );
  };

  const offerBanner = (): JSX.Element => {
    return (
      <div className="container" style={{ marginBottom: 0, marginTop: 40 }}>

        <div className="property-card">
          <div className="card-content">
            <img src={homeimg} alt="House" className="house-image" />
            <div className="text-section">
              <p className="card-text">
                Explore your recent property searches for rentals and PGs tailored to your preferences.
              </p>
              <button className="get-started-btn" onClick={() => navigate("/home")}>
                View Recent Searches <span className="arrow">↗</span>
              </button>

            </div>
          </div>
        </div>


      </div>
    );
  };



  const renderBanner = (): JSX.Element => {
    return (
      <div className="container" id="serachBanner">
        <div className="img-container" style={{ borderRadius: "9px", overflow: "hidden", height: "300px" }}>
          <img src="https://d3jbu7vaxvlagf.cloudfront.net/small/v2/category_media/image_17140377542125.jpeg" alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        </div>
      </div>
    )
  }



  const renderCards = (start: number, end: number) => {
    return propertyData?.data.slice(start, end).map((course: any, index, array) => {
      const isLast = index === array.length - 1;
      return (
        <>
          <SerachResultCard
            key={course?.id}
            course={course}
            isLast={isLast}
            section="top rated"
            index={index}
          />
        </>

      );
    });
  };


  const serachResult = (): JSX.Element => {
    return (
      <div style={{ marginBottom: 0, marginTop: 30 }}>

        {renderCards(0, 2)}

        {renderBanner()}

        {renderCards(3, 5)}

        {renderReelReview(properties?.properties)}

        {renderCards(6, 10)}
      </div>
    );
  };



  const renderReelReview = (courses: any[]): JSX.Element => {

    return (
      <div style={{ marginTop: 40 }}>

        {/* <components.BlockHeading
          title="Top Selling PG in Noida"
          containerStyle={{ marginBottom: 12, padding: '0 20px' }}
        /> */}

        {propertyData && Array.isArray(propertyData.data) && propertyData.data.length > 0 && (
          <components.BlockHeading
            title="Top Selling PG in Noida"
            containerStyle={{ marginBottom: 12, padding: '0 20px' }}
          />
        )}

        <Swiper spaceBetween={16} slidesPerView="auto">
          {propertyData?.data.map((item, index) => (
            <SwiperSlide
              key={item.property_id}
              style={{
                width: 200,
                height: 355,
                borderRadius: 10,
                overflow: 'hidden',
                backgroundColor: '#000',
                position: 'relative',
                cursor: 'pointer',
              }}
              onClick={() => {
                navigate("/course-details", { state: { item } });
              }}
            >
              <img
                src={
                  item.photos && item.photos.trim() !== ''
                    ? item.photos
                    : 'https://img.freepik.com/free-photo/view-luxurious-villa-with-modern-architectural-design_23-2151694133.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_items_boosted&w=740'
                }
                alt={item.photos || 'Property Image'}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: 10,
                }}
              />
              <div
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: 'rgba(0, 0, 0, 0.6)',
                  color: '#fff',
                  padding: '10px',
                  fontSize: 12,
                  lineHeight: 1.4,
                }}
              >
                <div style={{ marginBottom: 4, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item.property_name} {item.address} </div>
                <div style={{ marginBottom: 2 }}> • ₹{item.minimum_rent}/Month </div>
                <div>{item.city_name}</div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>


      </div>
    );
  };



  const renderContent = (): JSX.Element => {
    return (
      <main >
        {renderSearchBar2()}
        {/* {cardFormat()} */}
        {offerBanner()}
        {serachResult()}
        {/* {renderReelReview()} */}
      </main >
    );
  };





  const cardFormat = () => (
    <div className="container">
      <div className="cardContainer">


        {
          filterData.RoomType.length > 0 && (

            <div>
              <h1>Room Types</h1>
              {
                filterData.RoomType.map((item: string, index: number) => (

                  <>
                    <p>{item}</p>
                  </>
                ))
              }
            </div>
          )
        }


        {
          filterData.price.map((item: string, index: number) => (
            <p>{item}</p>
          ))
        }

        {
          filterData.selectedLocality.map((item: string, index: number) => (
            <p>{item}</p>
          ))
        }


      </div>
    </div>
  )



  return (
    <>
      {renderHeader()}

      {renderContent()}
      {renderBottomTabBar()}
    </>
  );
};










// 08-07-2025 CODE
// import axios from "axios";
// import { Swiper, SwiperSlide } from "swiper/react";
// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import useEmblaCarousel from "embla-carousel-react";

// import { text } from "../../text";
// import { URLS } from "../../config";
// import { hooks } from "../../hooks";
// import { utils } from "../../utils";
// import { svg } from "../../assets/svg";
// import { theme } from "../../constants";
// import { components } from "../../components";
// import { course as elements } from "../../course";
// import { review as reviews } from "../../reviews";

// import categoriesdata from "../../staticdata/categories";
// import properties from "../../staticdata/properties";
// import { reviewsData } from "../../staticdata/reviewData";
// import { CourseCard } from "../../course/CourseCard";
// import { SerachResultCard } from "../../course/SerachResultCard";
// import { FilterSvg } from "../../assets/svg/FilterSvg";
// import homeimg from '../../assets/nestfin/home.png'
// import logo from "../../assets/nestfin/NexfinPng.png"
// import { BottomTabBar } from "../../navigation/BottomTabBar";
// import { fetchPropertyByFilters } from "../../environment";
// import useApi from "../../customHook/useApi";
// import { callService } from "../../customHook/callService";



// export interface Feature {
//   feature_id: number;
//   feature_name: string;
//   icon: string;
// }

// export interface PropertyType {
//   property_id: string;
//   property_name: string;
//   address: string;
//   locality_id: string;
//   locality_name: string | null;
//   city_id: string;
//   city_name: string;
//   pincode: string;
//   state: string;
//   features: Feature[] | null;
//   photos: any; // can refine this later
//   minimum_rent: number;
// }

// export interface FilterResponse {
//   success: boolean;
//   statusCode: number;
//   data: PropertyType[];
// }


// export const Home2: React.FC = () => {


//   const navigate = hooks.useNavigate();
//   const location = useLocation();
//   const { pathname } = useLocation();
//   const [loading, setLoading] = useState(false);
//   const [emblaRef, emblaApi] = useEmblaCarousel();
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [coursesData, setCoursesData] = useState([]);
//   const [bannersData, setBannersData] = useState([]);
//   // const [categoriesData, setCategoriesData] = useState < any > [];
//   const [viewport, setViewport] = useState({
//     width: window.innerWidth,
//     height: window.innerHeight,
//   });

//   const [isFullscreen, setIsFullscreen] = useState(false);
//   const [startIndex, setStartIndex] = useState(0);




//   const [filterAPI, setFilterAPI] = useState<{
//     leadId: string;
//     selectedLocalityId: string;
//     genderAPI: string;
//     minAmount: number;
//     maxAmount: number;
//   }>({
//     leadId: "",  // coming from localstorage
//     selectedLocalityId: "",
//     genderAPI: "",
//     minAmount: 2000,
//     maxAmount: 8000
//   });


//   // API CALL
//   const {
//     data: propertyData,
//     loading: propertyLoading,
//     callApi: fetchProperty,
//   } = useApi<FilterResponse>(fetchPropertyByFilters, {
//     method: "POST",
//     autoCall: false,
//     dependencies: [],
//   });



//   useEffect(() => {
//     const selectedLocalityId = sessionStorage.getItem("SelectedLocalityId") || "";
//     const genderAPI = sessionStorage.getItem("genderAPI") || "";
//     let maxAmountStr = sessionStorage.getItem("maxAmount");
//     let minAmountStr = sessionStorage.getItem("minAmount");

//     if (!minAmountStr) {
//       minAmountStr = "1000";
//       sessionStorage.setItem("minAmount", minAmountStr);
//     }

//     if (!maxAmountStr) {
//       maxAmountStr = "30000";
//       sessionStorage.setItem("maxAmount", maxAmountStr);
//     }

//     const leadId = localStorage.getItem("lead_profile_id") || "";

//     // ✅ Set API filters for future use
//     setFilterAPI({
//       leadId,
//       selectedLocalityId,
//       genderAPI,
//       minAmount: Number(minAmountStr),
//       maxAmount: Number(maxAmountStr),
//     });

//     // ✅ Call API immediately
//     const payload = {
//       // leadId,
//       // gender: genderAPI,
//       // minAmount: Number(minAmountStr),
//       // maxAmount: Number(maxAmountStr),
//       // localityId: selectedLocalityId,
//       leadId: "LEAD-B-2025-05-001",
//       gender: "GENDER_MALE",
//       minAmount: 1,
//       maxAmount: 100000,
//       localityId: "5,7",
//     };

//     fetchProperty(payload);
//     console.log("Called API immediately with:", payload);
//     // ✅ Add delay before API call
//     // setTimeout(() => {
//     //   fetchProperty(payload);
//     //   console.log("Delayed API call with:", payload);
//     // }, 1000);
//   }, []);




//   // Log when propertyData updates


//   useEffect(() => {
//     if (propertyData) {
//       console.log("✅ API Response - propertyData:", propertyData);
//     }
//   }, [propertyData]);




//   useEffect(() => {
//     const handleResize = () => {
//       setViewport({
//         width: window.innerWidth,
//         height: window.innerHeight,
//       });
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);
//   useEffect(() => {
//     const scrollToTop = () => {
//       window.scrollTo(0, 0);
//       document.documentElement.scrollTop = 0;
//     };
//     scrollToTop();
//   }, [pathname]);
//   const handleSlideChange = () => {
//     if (emblaApi) {
//       setActiveIndex(emblaApi.selectedScrollSnap());
//     }
//   };
//   useEffect(() => {
//     if (emblaApi) {
//       emblaApi.on("select", handleSlideChange);
//     }
//   }, [emblaApi]);
//   useEffect(() => {
//     getData();
//   }, []);


//   // Call Lead Api
//   useEffect(() => {
//     const leadId = localStorage.getItem("lead_profile_id") || "";
//     const gender = sessionStorage.getItem("gender");
//     const state = "DELHI/NCR";
//     const city = sessionStorage.getItem("selectedCity") || "Noida";
//     const selectedLocalities = JSON.parse(sessionStorage.getItem("selectedLocality") || "[]");
//     const maxAmount = sessionStorage.getItem("maxAmount") || "30000";
//     const minAmount = sessionStorage.getItem("minAmount") || "0";


//     if (!leadId) return;

//     const payload = [
//       { param: "GENDER", value: gender },
//       { param: "STATE", value: state },
//       { param: "CITY", value: city },
//       { param: "LOCALITY", value: selectedLocalities },
//       { param: "MAXAMOUNT", value: maxAmount },
//       { param: "MINAMOUNT", value: minAmount },
//     ];

//     callService("VIEW_PROPERTY", payload)
//       .then((res) => {
//         console.log("✅ VIEW_PROPERTY response:", res);
//       })
//       .catch((err) => {
//         console.error("❌ VIEW_PROPERTY failed:", err);
//       });
//   }, []);




//   const getData = async () => {
//     setLoading(false);

//     // try {
//     //   const results = await Promise.allSettled([
//     //     axios.get(URLS.GET_COURSES),
//     //     axios.get(URLS.GET_CATEGORIES),
//     //     axios.get(URLS.GET_BANNERS),
//     //   ]);

//     //   const coursesResponse = results[0];
//     //   const categoriesResponse = categoriesdata;
//     //   const bannersResponse = results[2];

//     //   if (coursesResponse.status === "fulfilled") {
//     //     setCoursesData(coursesResponse.value.data.courses);
//     //   } else {
//     //     console.error("Error fetching courses:", coursesResponse.reason);
//     //   }

//     //   if (categoriesResponse.status === "fulfilled") {
//     //     // setCategoriesData(categoriesResponse?.categories);
//     //   } else {
//     //     // console.error('Error fetching categories:', categoriesResponse?.reason);
//     //   }

//     //   if (bannersResponse.status === "fulfilled") {
//     //     setBannersData(bannersResponse.value.data.banners);
//     //   } else {
//     //     console.error("Error fetching banners:", bannersResponse.reason);
//     //   }
//     // } catch (error) {
//     //   console.error("Unexpected error:", error);
//     // } finally {
//     //   setLoading(false);
//     // }
//   };



//   const filterData = location?.state?.filter;
//   // from locaiton value
//   useEffect(() => {
//     console.log(filterData, "from course details page");

//   }, [])



//   // component Start here

//   const renderHeader = (): JSX.Element => {
//     return (
//       <components.Header
//         goBack={false}
//         line={false}
//         leftlogo={true}
//         rightlogo={true}
//         // search={true}
//         filter={false}
//         // logo={true}
//         title={""}

//         centerImageSrc={logo}

//       />
//     );
//   };


//   const renderBottomTabBar = (): JSX.Element => {
//     return <BottomTabBar />;
//   };


//   const renderIndicator = (): JSX.Element => {
//     return (
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           bottom: 20,
//           left: 20,
//           flexDirection: "row",
//           gap: 8,
//         }}
//       >
//         {bannersData?.map((item: any, index: number) => {
//           const isSelected = index === activeIndex;
//           return (
//             <div
//               style={{
//                 background: isSelected
//                   ? "#7065F0"
//                   : theme.colors.secondaryTextColor,
//                 width: 10,
//                 // width: isSelected ? 25 : 10,
//                 height: 10,
//                 borderRadius: 5,
//               }}
//               key={index}
//             />
//           );
//         })}
//       </div>
//     );
//   };

//   const renderCarouselContent = (): JSX.Element => {
//     return (
//       <div
//         className="embla"
//         ref={emblaRef}
//         style={{ marginBottom: 20, marginTop: 40 }}
//       >
//         <div className="embla__container">
//           {bannersData.map((item: any, index: number, array: any[]) => {
//             return (
//               <div
//                 key={item.id}
//                 className="embla__slide"
//                 style={{
//                   position: "relative",
//                   width: "100%",
//                   overflow: "hidden",
//                   cursor: "pointer",
//                   userSelect: "none",
//                   padding: "0 20px",
//                 }}
//               >
//                 <img
//                   src={item.banner}
//                   style={{
//                     height: "100%",
//                     objectFit: "cover",
//                     borderRadius: 10,
//                   }}
//                   onClick={() => {
//                     navigate("/course-details", {
//                       state: { course: coursesData[0] },
//                     });
//                   }}
//                 />
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     );
//   };


//   const renderSearchBar2 = (): JSX.Element => {
//     return (
//       <div className="container">
//         <div className="searchBar">
//           <svg.SearchSvg />
//           <input
//             type="text"
//             placeholder="Search City, locality, landmark here"
//             className="searchInput"
//             onChange={() => console.log("onchangeActive")
//             }
//             onClick={() => navigate("/onbording6")}

//           />
//           <div
//             style={{ cursor: "pointer" }}
//             onClick={() => navigate("/onbording7")}

//           >
//             <FilterSvg color={"#7065F0"} />
//           </div>

//         </div>
//         <p style={{ fontSize: "13px", marginTop: "20px" }}>Selected Locality</p>
//         <div className="location-tag-group" style={{ gap: "5px" }}>

//           {/* <div className='addMoreBtn' onClick={() => navigate('/onbording6')} style={{ padding: "10px 25px" }} >+ Add More</div> */}
//           {filterData.selectedLocality?.map((city: string, index: number) => (
//             <div key={index} className="location-tag-wrapper" style={{ padding: "5px 10px", marginBottom: "0", background: "none", backgroundColor: "#7065f0d6", color: "white" }} >

//               {city}
//             </div>
//           ))}
//         </div>

//       </div >
//     );
//   };


//   // const renderSearchBar2 = (): JSX.Element => {
//   //   return (
//   //     <div className="container">

//   //       <div className="searchBar">
//   //         <div className="location-tag-group" >
//   //           {/* <div className='addMoreBtn' onClick={() => navigate('/onbording6')} style={{ padding: "10px 25px" }} >+ Add More</div> */}
//   //           {filterData.selectedLocality?.map((city: string, index: number) => (
//   //             <div key={index} className="location-tag-wrapper" style={{ padding: "10px 25px", marginBottom: "0" }} >

//   //               {city}
//   //             </div>
//   //           ))}
//   //         </div>
//   //         <div
//   //           style={{ cursor: "pointer" }}
//   //           onClick={() => navigate("/onbording7")}
//   //         >
//   //           <FilterSvg color={"#7065F0"} />
//   //         </div>

//   //       </div>

//   //     </div>
//   //   );
//   // };

//   const offerBanner = (): JSX.Element => {
//     return (
//       <div className="container" style={{ marginBottom: 0, marginTop: 40 }}>

//         <div className="property-card">
//           <div className="card-content">
//             <img src={homeimg} alt="House" className="house-image" />
//             <div className="text-section">
//               <p className="card-text">
//                 Explore your recent property searches for rentals and PGs tailored to your preferences.
//               </p>
//               <button className="get-started-btn">
//                 View Recent Searches <span className="arrow">↗</span>
//               </button>

//             </div>
//           </div>
//         </div>


//       </div>
//     );
//   };



//   const renderBanner = (): JSX.Element => {
//     return (
//       <div className="container" id="serachBanner">
//         <div className="img-container" style={{ borderRadius: "9px", overflow: "hidden", height: "300px" }}>
//           <img src="https://d3jbu7vaxvlagf.cloudfront.net/small/v2/category_media/image_17140377542125.jpeg" alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//         </div>
//       </div>
//     )
//   }



//   const renderCards = (start: number, end: number) => {
//     return propertyData?.data.slice(start, end).map((course: any, index, array) => {
//       const isLast = index === array.length - 1;
//       return (
//         <>
//           <SerachResultCard
//             key={course?.id}
//             course={course}
//             isLast={isLast}
//             section="top rated"
//             index={index}
//           />
//         </>

//       );
//     });
//   };


//   const serachResult = (): JSX.Element => {
//     return (
//       <div style={{ marginBottom: 0, marginTop: 30 }}>

//         {renderCards(0, 2)}

//         {renderBanner()}

//         {renderCards(3, 5)}

//         {renderReelReview(properties?.properties)}

//         {renderCards(6, 10)}
//       </div>
//     );
//   };


//   // old card container to show image
//   // const serachResult = (): JSX.Element => {
//   //   return (
//   //     <div style={{ marginBottom: 0, marginTop: 30 }}>



//   //       {properties?.properties.slice(0, 2).map((course: any, index, array) => {
//   //         const isLast = index === array.length - 1;

//   //         return (

//   //           <SerachResultCard
//   //             key={course.id}
//   //             course={course}
//   //             isLast={isLast}
//   //             section="top rated"
//   //             index={index}
//   //           />
//   //         );
//   //       })}

//   //       {renderBanner()}

//   //       {properties?.properties.slice(3, 5).map((course: any, index, array) => {
//   //         const isLast = index === array.length - 1;

//   //         return (

//   //           <SerachResultCard
//   //             key={course.id}
//   //             course={course}
//   //             isLast={isLast}
//   //             section="top rated"
//   //             index={index}
//   //           />
//   //         );
//   //       })}
//   //       {renderReelReview(properties?.properties)}

//   //       {properties?.properties.slice(6, 10).map((course: any, index, array) => {
//   //         const isLast = index === array.length - 1;

//   //         return (

//   //           <SerachResultCard
//   //             key={course.id}
//   //             course={course}
//   //             isLast={isLast}
//   //             section="top rated"
//   //             index={index}
//   //           />
//   //         );
//   //       })}
//   //     </div>
//   //   );
//   // };


//   // const renderReelReview = (courses: any[]): JSX.Element => {

//   //   const videoList = [
//   //     {
//   //       id: 1,
//   //       src: 'https://img.freepik.com/free-photo/beautiful-suburban-house-with-green-lawn-sunny-day_23-2151974428.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_items_boosted&w=740',
//   //       type: 'Semi Furnished',
//   //       price: '₹5000/Month',
//   //       title: 'Stylish 1 BHK Apartments for Rent',
//   //       location: 'Model Town, New Delhi',
//   //     },
//   //     {
//   //       id: 2,
//   //       src: 'https://img.freepik.com/free-photo/beautiful-modern-door_23-2151977061.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_items_boosted&w=740',
//   //       type: 'Fully Furnished',
//   //       price: '₹7500/Month',
//   //       title: 'Comfortable PG Rooms for Girls',
//   //       location: 'Nirman Vihar, Delhi',
//   //     },
//   //     {
//   //       id: 3,
//   //       src: 'https://img.freepik.com/free-photo/view-luxurious-villa-with-modern-architectural-design_23-2151694133.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_items_boosted&w=740',
//   //       type: 'Unfurnished',
//   //       price: '₹4500/Month',
//   //       title: 'Spacious Room for Rent with Balcony',
//   //       location: 'Sector 62, Noida',
//   //     },
//   //     {
//   //       id: 4,
//   //       src: 'https://img.freepik.com/premium-photo/no-humans-scenery-sky-outdoors-grass-tree-blue-sky-window-house-day-building-door_943272-2249.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_items_boosted&w=740',
//   //       type: 'Semi Furnished',
//   //       price: '₹6000/Month',
//   //       title: 'Affordable PG Accommodation for Students',
//   //       location: 'Sector 63, Noida',
//   //     },
//   //   ];

//   //   return (
//   //     <div style={{ marginTop: 40 }}>
//   //       <components.BlockHeading
//   //         title="Top Selling PG in Noida"
//   //         // viewAllOnClick={() => { }}
//   //         containerStyle={{ marginBottom: 12, padding: '0 20px' }}
//   //       />
//   //       <Swiper spaceBetween={16} slidesPerView="auto">
//   //         {videoList.map((item, index) => (
//   //           <SwiperSlide
//   //             key={item.id}
//   //             style={{
//   //               width: 200,
//   //               height: 355,
//   //               borderRadius: 10,
//   //               overflow: 'hidden',
//   //               backgroundColor: '#000',
//   //               position: 'relative',
//   //               cursor: 'pointer',
//   //             }}
//   //             onClick={() => {
//   //               navigate("/course-details", { state: { item } });
//   //             }}
//   //           >
//   //             <img
//   //               src={item.src}
//   //               alt={item.type}
//   //               style={{
//   //                 width: '100%',
//   //                 height: '100%',
//   //                 objectFit: 'cover',
//   //                 borderRadius: 10,
//   //               }}
//   //             />
//   //             <div
//   //               style={{
//   //                 position: 'absolute',
//   //                 bottom: 0,
//   //                 left: 0,
//   //                 right: 0,
//   //                 background: 'rgba(0, 0, 0, 0.6)',
//   //                 color: '#fff',
//   //                 padding: '10px',
//   //                 fontSize: 12,
//   //                 lineHeight: 1.4,
//   //               }}
//   //             >
//   //               <div style={{ marginBottom: 4, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item.title}</div>
//   //               <div style={{ marginBottom: 2 }}>{item.type} • {item.price}</div>
//   //               <div>{item.location}</div>
//   //             </div>
//   //           </SwiperSlide>
//   //         ))}
//   //       </Swiper>


//   //     </div>
//   //   );
//   // };


//   const renderReelReview = (courses: any[]): JSX.Element => {

//     return (
//       <div style={{ marginTop: 40 }}>

//         {/* <components.BlockHeading
//           title="Top Selling PG in Noida"
//           containerStyle={{ marginBottom: 12, padding: '0 20px' }}
//         /> */}

//         {propertyData && Array.isArray(propertyData.data) && propertyData.data.length > 0 && (
//           <components.BlockHeading
//             title="Top Selling PG in Noida"
//             containerStyle={{ marginBottom: 12, padding: '0 20px' }}
//           />
//         )}


//         {/* {
//           propertyData?.data?.length > 0 && (
//             <components.BlockHeading
//               title="Top Selling PG in Noida"
//               containerStyle={{ marginBottom: 12, padding: '0 20px' }}
//             />
//           )
//         } */}


//         <Swiper spaceBetween={16} slidesPerView="auto">
//           {propertyData?.data.map((item, index) => (
//             <SwiperSlide
//               key={item.property_id}
//               style={{
//                 width: 200,
//                 height: 355,
//                 borderRadius: 10,
//                 overflow: 'hidden',
//                 backgroundColor: '#000',
//                 position: 'relative',
//                 cursor: 'pointer',
//               }}
//               onClick={() => {
//                 navigate("/course-details", { state: { item } });
//               }}
//             >
//               <img
//                 src={
//                   item.photos && item.photos.trim() !== ''
//                     ? item.photos
//                     : 'https://img.freepik.com/free-photo/view-luxurious-villa-with-modern-architectural-design_23-2151694133.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_items_boosted&w=740'
//                 }
//                 alt={item.photos || 'Property Image'}
//                 style={{
//                   width: '100%',
//                   height: '100%',
//                   objectFit: 'cover',
//                   borderRadius: 10,
//                 }}
//               />
//               <div
//                 style={{
//                   position: 'absolute',
//                   bottom: 0,
//                   left: 0,
//                   right: 0,
//                   background: 'rgba(0, 0, 0, 0.6)',
//                   color: '#fff',
//                   padding: '10px',
//                   fontSize: 12,
//                   lineHeight: 1.4,
//                 }}
//               >
//                 <div style={{ marginBottom: 4, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item.property_name} {item.address} </div>
//                 <div style={{ marginBottom: 2 }}> • ₹{item.minimum_rent}/Month </div>
//                 <div>{item.city_name}</div>
//               </div>
//             </SwiperSlide>
//           ))}
//         </Swiper>


//       </div>
//     );
//   };



//   const renderContent = (): JSX.Element => {
//     return (
//       <main >
//         {renderSearchBar2()}
//         {/* {cardFormat()} */}
//         {offerBanner()}
//         {serachResult()}
//         {/* {renderReelReview()} */}
//       </main >
//     );
//   };

//   // const renderContent = (): JSX.Element => {
//   //   return (
//   //     <main>
//   //       {propertyLoading && (
//   //         <div
//   //           style={{
//   //             position: "fixed",
//   //             top: "20px",
//   //             left: "50%",
//   //             transform: "translateX(-50%)",
//   //             zIndex: 9999,
//   //           }}
//   //         >
//   //           <div className="spinner" />
//   //         </div>
//   //       )}

//   //       {!propertyLoading && (
//   //         <>
//   //           {renderSearchBar2()}
//   //           {/* {cardFormat()} */}
//   //           {/* {offerBanner()} */}
//   //           {serachResult()}
//   //           {/* {renderReelReview()} */}
//   //         </>
//   //       )}
//   //     </main>
//   //   );
//   // };




//   const cardFormat = () => (
//     <div className="container">
//       <div className="cardContainer">


//         {
//           filterData.RoomType.length > 0 && (

//             <div>
//               <h1>Room Types</h1>
//               {
//                 filterData.RoomType.map((item: string, index: number) => (

//                   <>
//                     <p>{item}</p>
//                   </>
//                 ))
//               }
//             </div>
//           )
//         }


//         {
//           filterData.price.map((item: string, index: number) => (
//             <p>{item}</p>
//           ))
//         }

//         {
//           filterData.selectedLocality.map((item: string, index: number) => (
//             <p>{item}</p>
//           ))
//         }


//       </div>
//     </div>
//   )



//   return (
//     <>
//       {renderHeader()}

//       {renderContent()}
//       {renderBottomTabBar()}
//     </>
//   );
// };








